import api from './client'

export interface CatalogService {
  id: string
  companyId: string
  name: string | null
  nameIt: string | null
  price: string // decimal comes back as string
  isActive: boolean
  createdAt: string
  updatedAt: string
}

const base = (cid: string) => `/companies/${cid}/services`

export const servicesApi = {
  list: (cid: string, opts?: { search?: string; includeInactive?: boolean }) =>
    api.get<CatalogService[]>(base(cid), {
      params: { search: opts?.search || undefined, includeInactive: opts?.includeInactive ? 'true' : undefined },
    }).then(r => r.data),

  create: (cid: string, dto: { name?: string; nameIt?: string; price: number }) =>
    api.post<CatalogService>(base(cid), dto).then(r => r.data),

  update: (cid: string, id: string, dto: { name?: string; nameIt?: string; price?: number; isActive?: boolean }) =>
    api.patch<CatalogService>(`${base(cid)}/${id}`, dto).then(r => r.data),

  remove: (cid: string, id: string) => api.delete(`${base(cid)}/${id}`),
}
